import type { ReactNode } from "react";
import React from "react";
import { useNavigate } from "react-router-dom";
// biome-ignore lint/style/useNamingConvention: a JSX component must stay capitalised or it renders as an intrinsic element
import MFAComponent from "@page/auth/component/MFAComponent";

interface Props {
	phone: string;
	redirectTo: string;
	onCodeAccepted?: () => PromiseLike<unknown>;
}

export default function MfaWithRedirect({ phone, redirectTo, onCodeAccepted }: Props): ReactNode {
	const navigate = useNavigate();

	return <MFAComponent phone={phone} onCodeAccepted={onCodeAccepted} onVerified={() => navigate(redirectTo, { replace: true })} />;
}
